import React from "react";
import type { Job } from "../../types";
import { getJobDisplayStatus } from "../../utils/jobStatus";

const statusStyles: Record<Job["status"], string> = {
  pending: "bg-yellow-100 text-yellow-800 dark:bg-yellow-500/20 dark:text-yellow-300 border-yellow-200 dark:border-yellow-500/30",
  scheduled: "bg-blue-100 text-blue-800 dark:bg-blue-500/20 dark:text-blue-300 border-blue-200 dark:border-blue-500/30",
  in_progress: "bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-300 border-amber-200 dark:border-amber-500/30",
  completed: "bg-green-100 text-green-800 dark:bg-green-500/20 dark:text-green-300 border-green-200 dark:border-green-500/30",
  cancelled: "bg-red-100 text-red-800 dark:bg-red-500/20 dark:text-red-300 border-red-200 dark:border-red-500/30",
};

const statusLabels: Record<Job["status"], string> = {
  pending: "En attente",
  scheduled: "Planifié",
  in_progress: "En cours",
  completed: "Terminé",
  cancelled: "Annulé",
};

const assignedStyle = "bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-300 border-amber-200 dark:border-amber-500/30";

export const StatusBadge = ({ status, installerId, date }: { status: Job["status"]; installerId?: string; date?: string }) => {
  const displayStatus = getJobDisplayStatus({ status, date });
  const isAssignedOnly = status === "pending" && !date?.trim() && !!installerId;
  const label = isAssignedOnly ? "Assigné" : statusLabels[displayStatus];
  const style = isAssignedOnly ? assignedStyle : statusStyles[displayStatus];
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${style}`}
    >
      {label}
    </span>
  );
};
